import React, { Component } from 'react'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { Card, Button, Col, Row, Alert } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { FORM_EDICION_CARATULA } from '../../../config/forms'
import {
  TABLA_COEMS_CERRADOS,
  TABLA_COEMS_ANULADOS
} from '../../../config/tables'
import CamposCaratulaCierreDeCarga from './CamposCaratulaCierreDeCarga'

const selector = formValueSelector(FORM_EDICION_CARATULA)

class DialogoCierreDeCarga extends Component {
  constructor (props) {
    super(props)
    this.changeZarpada = this.changeZarpada.bind(this)
  }

  componentDidMount () {
    const { id, change: formChange } = this.props
    this.props.getConsultaDatosCaratula(id)
    this.props.actualizarDatosCoemsCerradosParaMuiTable(id)
    this.props.actualizarDatosCoemsAnuladosParaMuiTable(id)
    this.props.obtenerTotales(id, formChange)
  }

  changeZarpada (e) {
    const { change: formChange } = this.props
    formChange('fechaZarpada', e.target.value)
  }

  render () {
    const {
      id,
      handleClose,
      handleSubmit,
      consultaCaratula,
      pesoTotalEmbarcado,
      codigoAduana,
      idAduana,
      mensajeAduana,
      isRequestingSoap
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Cierre de Carga</Card.Text>
          </Card.Header>
          <Card.Body>
            <div>
              {(!consultaCaratula && !pesoTotalEmbarcado) && <div className='circular-progress-consulta-soap'>
                <CircularProgress thickness='5' size='5rem' style={{ margin: '0 auto' }} />
              </div>}
              {(consultaCaratula && pesoTotalEmbarcado) && <div>
                <Row>
                  <Col md={4}>
                    <span style={{ fontSize: 'large' }}>Buque: </span>
                    <span style={{ fontWeight: 'bold', fontSize: 'large' }}>{consultaCaratula.nombreBuque}</span>
                  </Col>
                  <Col md={8}>
                    <span style={{ fontSize: 'large' }}>Carátula: </span>
                    <span style={{ fontWeight: 'bold', fontSize: 'large' }}>{consultaCaratula.identificadorCaratula}</span>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <span style={{ fontSize: 'large' }}>Giro: </span>
                    <span style={{ fontWeight: 'bold', fontSize: 'large' }}>{consultaCaratula.nombreGiro}</span>
                  </Col>
                </Row>
                <hr />
                <CamposCaratulaCierreDeCarga
                  fechaZarpada={moment().format('YYYY-MM-DD[T]HH:mm')}
                  //fechaZarpada={consultaCaratula.fechaDeZarpada}
                  changeZarpada={this.changeZarpada} />
                <br />
              </div> }
              {(codigoAduana && mensajeAduana) && (<div className='circular-progress-consulta-soap'>
                <Row>
                  <Alert fade show variant='secondary'>
                    <Alert.Heading>Atención!!!</Alert.Heading>
                    <p style={{ fontSize: 'medium' }}>Código: <strong>{codigoAduana}</strong></p>
                    <p style={{ fontSize: 'medium' }}>Descripción: <strong>{mensajeAduana}</strong></p>
                    {idAduana && <p style={{ fontSize: 'medium' }}>Identificador de Aduana: {idAduana}</p>}
                  </Alert>
                </Row>
                <br />
              </div>)}
              {(isRequestingSoap) && <div className='circular-progress-consulta-soap'>
                <CircularProgress thickness='5' size='5rem' style={{ margin: '0 auto' }} />
              </div>}
              <MuiTable id={TABLA_COEMS_CERRADOS} />
              <MuiTable id={TABLA_COEMS_ANULADOS} />
            </div>
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={() => handleSubmit(id)} >Solicitar Cierre de Carga</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCaratula: state.comunicacionEmbarque.consultaCaratula,
    codigoAduana: state.comunicacionEmbarque.codigoAduana,
    idAduana: state.comunicacionEmbarque.idAduana,
    mensajeAduana: state.comunicacionEmbarque.mensajeAduana,
    isRequestingSoap: state.comunicacionEmbarque.isRequestingSoap,
    fechaZarpada: selector(state, 'fechaZarpada'),
    pesoTotalEmbarcado: state.comunicacionEmbarque.pesoTotalEmbarcado
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_CARATULA,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCierreDeCarga))
